m = require 'mithril'

ActionFactories = require '../../state/ActionFactories'
Hand 			= require '../../lib/Hand'

CommonViews 	= require '../components/CommonViews'
Breadcrumbs 	= require '../components/Breadcrumbs'
ControlBlock 	= require '../components/ControlBlock'
DeleteButton 	= require '../components/DeleteButton'
RoundViewModel 	= require '../components/RoundViewModel'

RoundPage = {
	controller: (args) ->
		game = args.game()
		round = game.rounds[args.roundNumber()]
		vm = new RoundViewModel game.players, round

		{
			vm
			viewGame: () -> m.route "/game/#{game.id}"
			onRoundRemoved: () ->
				args.removeRound()
				m.route "/game/#{game.id}"
			onRoundSaved: (e) ->
				e.preventDefault()
				args.updateRound vm.buildRound()
				m.route "/game/#{game.id}"
		}

	view: (ctrl, args) ->
		players = ctrl.vm.players()
		game = args.game()

		CommonViews.page [
			m Breadcrumbs, {items: [
				{url: '/', label: 'Games', icon: CommonViews.icons.home}
				{url: "/game/#{args.game().id}", label: "#{game.label} (#{game.date})", icon: CommonViews.icons.spades}
				{label: "Round ##{args.roundNumber()+1}", icon: CommonViews.icons.pencil}
			]}

			CommonViews.pageHeading "Round ##{args.roundNumber()+1}"

			m 'form', {onsubmit: ctrl.onRoundSaved}, [
				CommonViews.table [
					m 'tr', [
						m 'th', ''
						m 'th.left', "#{p.name}" for p in players
					]
				],[
					winnerRow players, ctrl.vm.playerHands
					pickerFieldRow 'Red threes', 'redThrees', players, ctrl.vm.playerHands, 4
					pickerFieldRow 'Mixed canastas', 'mixedCanastas', players, ctrl.vm.playerHands, 12
					pickerFieldRow 'Natural canastas', 'naturalCanastas', players, ctrl.vm.playerHands, 12
					numberFieldRow 'Points in melds', 'pointsInMelds', players, ctrl.vm.playerHands
					numberFieldRow 'Points in hand', 'pointsInHand', players, ctrl.vm.playerHands
				]
				
				m 'p', 'Click save to update the scores for this round.'
				m ControlBlock, {content: [
					m 'button[type=submit]', [
						CommonViews.icon CommonViews.icons.floppydisk, 'button_icon'
						'Save'
					]
					m 'span.link', {onclick: ctrl.viewGame}, 'Cancel'
				]}
			]
			
			m 'hr'
			m ControlBlock, {content: [
				m DeleteButton, {
					message: 'If you created this round in error then click delete to permanently remove it.'
					label: 'Delete round'
					onclick: ctrl.onRoundRemoved
				}
			]}
		]
}

winnerRow = (players, handsVm) ->
	m 'tr', [
		m 'th', 'Win?'
		winnerCell p, handsVm for p in players
	]

winnerCell = (p, handsVm) ->
	prop = handsVm[p.id].status
	m 'td', [
		winnerRadio 'Win', Hand.WinTypes.Win, prop
		m 'br'
		winnerRadio 'Blind win', Hand.WinTypes.Blind, prop
	]

winnerRadio = (label, winType, prop) ->
	m 'label', [
		m 'input[type=radio][name=winner]', {
			checked: prop() is winType
			onchange: (e) -> prop(if e.srcElement.checked then winType else null)
		}
		label
	]

pickerFieldRow = (label, field, players, handsVm, max) ->
	m 'tr', [
		m 'th', label
		players.map (p) ->
			prop = handsVm[p.id][field]
			m 'td',
				m "select.number", {
					value: prop()
					onchange: m.withAttr 'value', prop
				}, [0..max].map (i) -> m "option[value=#{i}]", i
	]

numberFieldRow = (label, field, players, handsVm) ->
	m 'tr', [
		m 'th', label
		players.map (p) ->
			prop = handsVm[p.id][field]
			m 'td',
				m "input.number[type=number][min=0][step=5]", {
					value: prop()
					onchange: m.withAttr 'value', prop
				}
	]

module.exports = (store) ->
	m.component RoundPage, {
		roundNumber: () -> parseInt m.route.param 'round'
		game: () -> store.getState().gamesById[m.route.param 'id']
		removeRound: () ->
			gameId = m.route.param 'id'
			roundNumber = parseInt m.route.param 'round'
			store.dispatch ActionFactories.roundRemoved gameId, roundNumber
		updateRound: (round) ->
			gameId = m.route.param 'id'
			roundNumber =parseInt m.route.param 'round'
			store.dispatch ActionFactories.roundUpdated gameId, roundNumber, round
	}